export const roles = {
  ADMIN: 'Admin',
  CREATOR: 'Creator',
} as const
